"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.reduce-right.js");

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTailwindClasses = exports.defaultSnapData = exports.withTuple = exports.getSnapFrom = void 0;

var lodash_1 = require("lodash");
/**
 * Curry function that returns a withTuple to be used a snapOptions function.
 * @param media: The media query of the tuple
 * @param width: The width of the Tuple
 * @param className the class name of the tuple
 * @returns: a Tuple with the given information
 * @see snapOptions
 */


var withTuple = function withTuple(media) {
  return function (width) {
    return function (className) {
      return function (tuples) {
        return __spreadArrays([{
          media: media,
          width: width,
          className: className
        }], tuples);
      };
    };
  };
};

exports.withTuple = withTuple;
/**
 * withTailwindClasses returns a withTuple function that take the tailwind class and creates
 * tuples for each one of them.
 * @param tailwindConfig The Tailwind config to use for extraction of size data
 * @param classes: THe tailwind classes
 */

var withTailwindClasses = function withTailwindClasses(tailwindConfig) {
  return function (classes) {
    return function (tuples) {
      return __spreadArrays(classes.split(' ').map(function (className) {
        var _a = (className.match(':') ? className : ":" + className).split(':'),
            mediaPrefix = _a[0],
            widthClassName = _a[1];

        var widthSuffix = widthClassName.replace(/^w-/, ''); // If we do not have the screen then we move forward with no screen
        // tslint:disable-next-line: max-line-length

        var media = "(min-width: " + (mediaPrefix ? tailwindConfig.theme.screens[mediaPrefix] : '0px') + ")";
        var width = parseInt(tailwindConfig.theme.width[widthSuffix], 10);
        return {
          media: media,
          width: width,
          className: className
        };
      }), tuples);
    };
  };
};

exports.withTailwindClasses = withTailwindClasses;
/**
 * getWidths extracts all of the unquie widths from an array of withTuples
 * @param options The withTuple to be inspected
 */

var getWidths = function getWidths(options) {
  return options.map(function (item) {
    return item.width;
  }).reduce(function (unique, item) {
    return unique.includes(item) ? unique : __spreadArrays(unique, [item]);
  }, []);
};
/**
 * getClassNames extracts all of the unquie classNames from an array of withTuples
 * @param options The withTuple to be inspected
 */


var getClassNames = function getClassNames(options) {
  return options.map(function (item) {
    return item.className;
  }).reduce(function (unique, item) {
    return unique.includes(item) ? unique : __spreadArrays(unique, [item]);
  }, []);
};
/**
 * getMedias extracts all of the unquie widths from an array of withTuples
 * @param options The withTuple to be inspected
 */


var getMedias = function getMedias(options) {
  return options.map(function (item) {
    return item.media;
  }).reduce(function (unique, item) {
    return unique.includes(item) ? unique : __spreadArrays([item], unique);
  }, []);
};

var getMediaMatch = function getMediaMatch(matchMedia) {
  return function (medias) {
    return medias.reduceRight( // walk though each of the media strings and return the last true one
    function (acc, media) {
      return matchMedia(media).matches ? media : acc;
    }, '');
  };
};

var filterByMedia = function filterByMedia(media) {
  return function (tuples) {
    return tuples.filter(function (item) {
      return item.media === media;
    });
  };
};

var filterByWidth = function filterByWidth(width) {
  return function (tuples) {
    return tuples.filter(function (item) {
      return item.width === width;
    });
  };
}; // tslint:disable-next-line: ter-arrow-parens


var getSnapFrom = function getSnapFrom() {
  var withTuples = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    withTuples[_i] = arguments[_i];
  }

  return function (props) {
    var currentWidth = props.width,
        currentClassName = props.className,
        matchMediaRaw = props.matchMedia;
    var tuples = lodash_1.flowRight.apply(void 0, withTuples)([]);
    var matchMedia = matchMediaRaw || window.matchMedia;
    var currentMedia = getMediaMatch(matchMedia)(getMedias(tuples));
    var currentMediaTuples = filterByMedia(currentMedia)(tuples);
    var currentTuple = currentMediaTuples.find(function (tuple) {
      return currentClassName.split(' ').includes(tuple.className);
    }); // Find the first width for which the input width is smaller
    // If no with pass then use the one from our current class

    var width = typeof currentWidth !== 'undefined' ? getWidths(currentMediaTuples).find(function (w) {
      return w >= currentWidth;
    }) || 100 : currentTuple && currentTuple.width || 100;
    var currentWidthTuples = filterByWidth(width)(currentMediaTuples);
    var className = currentClassName.split(' ') // remove all class that relate to the media query
    .filter(function (item) {
      return !getClassNames(currentMediaTuples).includes(item);
    }) // add the class that is for the current width
    .concat(currentWidthTuples.length > 0 ? currentWidthTuples[0].className : '').join(' ');
    return {
      width: width,
      className: className
    };
  };
};

exports.getSnapFrom = getSnapFrom;
var defaultSnapData = getSnapFrom(withTuple('(min-width: 0px)')(100)('w-full'), withTuple('(min-width: 576px)')(25)('sm:w-1/4'), withTuple('(min-width: 576px)')(33.33)('sm:w-1/3'), withTuple('(min-width: 576px)')(50)('sm:w-1/2'), withTuple('(min-width: 576px)')(66.66)('sm:w-2/3'), withTuple('(min-width: 576px)')(75)('sm:w-3/4'), withTuple('(min-width: 576px)')(100)('sm:w-full'), withTuple('(min-width: 992px)')(25)('lg:w-1/4'), withTuple('(min-width: 992px)')(33.33)('lg:w-1/3'), withTuple('(min-width: 992px)')(50)('lg:w-1/2'), withTuple('(min-width: 992px)')(66.66)('lg:w-2/3'), withTuple('(min-width: 992px)')(75)('lg:w-3/4'), withTuple('(min-width: 992px)')(100)('lg:w-full'));
exports.defaultSnapData = defaultSnapData;